import * as angular from 'angular';

import { CoreHeaderComponent } from './coreHeader.component';
import { CoreHeaderDetailsComponent } from './coreHeaderDetails.component';
import HeaderDetailsContractFactory from './headerDetailsContract.factory';
import HeaderDetailsRfpFactory from './headerDetailsRfp.factory';

export default angular
  .module('coreLayoutHeader', [])
  .component('coreHeader', CoreHeaderComponent)
  .component('coreHeaderDetails', CoreHeaderDetailsComponent)
  .factory('HeaderDetailsContract', HeaderDetailsContractFactory)
  .factory('HeaderDetailsRfp', HeaderDetailsRfpFactory)
  .run(function ($templateCache) {
    'ngInject';
    $templateCache.put(
      'optimizedMixPopover',
      require('./optimized-mix.popover.html'),
    );
  }).name;
